import s from '@/styles/components/Tooltip.module.scss'
import { ButtonTapHighlight, Icon } from '@/components'
import { ForwardedRef, forwardRef } from 'react'
import { classNames } from '@tmap-web-lib/utils'

export type Tooltip = {
  title?: string;
  description: string[];
  additional?: string;
  isNotBullet?: boolean;
}

export type ObjTooltip = {
  [index: string]: Tooltip;
}

interface Props {
  id: string;
  tooltip: Tooltip;
  handleClose: (id: string) => void;
}

const Tooltip = forwardRef(({ id, tooltip, handleClose }: Props, ref: ForwardedRef<HTMLDivElement>) => {
  const { title, description, additional, isNotBullet } = tooltip

  return (
    <div ref={ref} id={id} className={s.wrap}>
      {title && (<h1 className={s.title}>{title}</h1>)}
      <div className={s.content}>
        <ul className={s.description}>
          {description.map((item, index) => {
            return (
              <li
                key={index}
                className={classNames(s.description_item, isNotBullet ? s.no_bullet : undefined, !title ? s.only_desc : undefined)}
              >
                {item}
              </li>
            )
          })}
        </ul>
        {additional && <p className={s.additional}>{additional}</p>}
      </div>
      <ButtonTapHighlight
        className={s.close}
        onClick={() => handleClose(id)}
      >
        <Icon name={'Exit'} size={20} color={'--icon-tertiary'} />
      </ButtonTapHighlight>
    </div>
  )
})

Tooltip.displayName = 'Tooltip'
export { Tooltip }
